/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;



import Vue from "vue";
import Vuetify from "../plugins/vuetify"
import VueRouter from "vue-router"
import { store } from "./store"

import VueSweetalert2 from 'vue-sweetalert2';


import "../plugins/vuetify-money";
import { localDateString } from "./helpers/dateHelpers";

Vue.prototype.$localDateString = localDateString;

import HomePage from "./components/pages/HomePage"
import SettingsPage from "./components/pages/SettingsPage"
import PrimerPage from "./components/pages/PrimerPage"
import DocumentTypesPage from "./components/pages/DocumentTypesPage"
import ChargeTypesPage from "./components/pages/ChargeTypesPage"
import PackagesPage from "./components/pages/PackagesPage"
import ProductCategoriesPage from "./components/pages/ProductCategoriesPage.vue"
import VehiclesPage from "./components/pages/VehiclesPage"
import CompanyPage from "./components/pages/CompanyPage"
import CustomersPage from "./components/pages/CustomersPage"
import NewTransportationDocumentPage from "./components/pages/NewTransportationDocumentPage"
import TransportationDocumentsPage from "./components/pages/TransportationDocumentsPage"
import LedgersPage from "./components/pages/LedgersPage"
import ContractsPage from "./components/pages/ContractsPage.vue"

import NewIncomeDocumentPage from "./components/pages/NewIncomeDocumentPage"
import IncomeDocumentsPage from "./components/pages/IncomeDocumentsPage"
import EditTransportationDocumentPage from "./components/pages/EditTransportationDocumentPage"

import NewServiceDocumentPage from "./components/pages/NewServiceDocumentPage"
import ServiceDocumentsPage from "./components/pages/ServiceDocumentsPage"
import EditServiceDocumentPage from "./components/pages/EditServiceDocumentPage"

import ProductsPage from "./components/pages/ProductsPage"
import NewSalesDocumentPage from "./components/pages/NewSalesDocumentPage"
import SalesDocumentsPage from "./components/pages/SalesDocumentsPage"

import NewPurchaseDocumentPage from "./components/pages/NewPurchaseDocumentPage"
import EditPurchaseDocumentPage from "./components/pages/EditPurchaseDocumentPage"
import PurchaseDocumentsPage from "./components/pages/PurchaseDocumentsPage"
import WarehouseDocumentsPage from "./components/pages/WarehouseDocumentsPage"
import NewWarehouseDocumentPage from "./components/pages/NewWarehouseDocumentPage"

import SalesPage from "./components/pages/SalesPage"
import BranchStocksPage from "./components/pages/BranchStocksPage"

import NewWarehouseDocumentInvoicePage from "./components/pages/NewWarehouseDocumentInvoicePage"

import NewPaymentDocumentPage from "./components/pages/NewPaymentDocumentPage"
import PaymentDocumentsPage from "./components/pages/PaymentDocumentsPage"

import NewInternalShippingDocumentPage from "./components/pages/NewInternalShippingDocumentPage"
import InternalShippingDocumentsPage from "./components/pages/InternalShippingDocumentsPage"


import AccountLedgerPage from "./components/pages/AccountLedgerPage"
import ReportSalesAveragesPage from "./components/pages/ReportSalesAveragesPage"
import ReportSalesPerCustomerPage from "./components/pages/ReportSalesPerCustomerPage"
import ReportCustomersBalancePage from "./components/pages/ReportCustomersBalancePage"
import ReportSalesPerDayPage from "./components/pages/ReportSalesPerDayPage"
import ReportOrderSumsPerCustomerPage from "./components/pages/ReportOrderSumsPerCustomerPage"
import ReportSalesPerProductPage from "./components/pages/ReportSalesPerProductPage"
import ReportSalesSumsPerCustomerPage from "./components/pages/ReportSalesSumsPerCustomerPage"
import ReportOrderSumsPerDistributorPage from "./components/pages/ReportOrderSumsPerDistributorPage"
import ReportExportEsodaEpsilonBPage from "./components/pages/ReportExportEsodaEpsilonBPage"
import ReportExportEksodaEpsilonBPage from "./components/pages/ReportExportEksodaEpsilonBPage"
import ReportExportAccountsEpsilonPage from "./components/pages/ReportExportAccountsEpsilonPage"
import ReportFortoseisAnaDianomeaPage from "./components/pages/ReportFortoseisAnaDianomeaPage"
import ReportOrderSumsPerSupplierPage from "./components/pages/ReportOrderSumsPerSupplierPage"
import ReportQuantityPerMonthPage from "./components/pages/ReportQuantityPerMonthPage"
import ReportStockMovementsPage from "./components/pages/ReportStockMovementsPage.vue";
import ReportPurchasesPerSupplier from "./components/pages/ReportPurchasesPerSupplierPage.vue"; 
import ReportTzirosPerMonth from "./components/pages/ReportTzirosPerMonthPage.vue";
import ReportExportEsodaEpsilonCPage from "./components/pages/ReportExportEsodaEpsilonC.vue"
import ReportExportEksodaEpsilonCPage from "./components/pages/ReportExportEksodaEpsilonC.vue"

import NewExpensePage from "./components/pages/NewExpensePage"
import ExpenseDocumentsPage from "./components/pages/ExpenseDocumentsPage"
import ExpenseTemplatesPage from "./components/pages/ExpenseTemplatesPage"

import SalesOrderDocumentsPage from "./components/pages/SalesOrderDocumentsPage"
import NewSalesOrderDocumentPage from "./components/pages/NewSalesOrderDocumentPage"

import NewSalesOrderDocumentInvoicePage from "./components/pages/NewSalesOrderDocumentInvoicePage"
import ContractPage from "./components/pages/ContractPage";

import NewOffsetTransactionPage from "./components/pages/NewOffsetTransactionPage"

import PricelistsPage from "./components/pages/PricelistsPage"
import PricelistEditorPage from "./components/pages/PricelistEditorPage"
import ReportsPage from "./components/pages/ReportsPage"

// import DistributionItinerariesPerDayPage from "./components/pages/DistributionItinerariesPerDayPage.vue";

import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueRouter)
Vue.use(VueSweetalert2)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


Vue.component('app-container', require('./components/AppContainer.vue').default);
Vue.component('login-form', require('./components/LoginForm.vue').default);
Vue.component('file-uploader', require('./components/FileUploader.vue').default);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/home',
            name: 'home',
            component: HomePage
        },
        {
            path: '/settings',
            name: 'settings',
            component: SettingsPage
        },
        {
            path: '/primer',
            name: 'primer',
            component: PrimerPage
        },
        {
            path: '/reports',
            name: 'reports',
            component: ReportsPage
        },
        {
            path: '/document-types',
            name: 'documenttypes',
            component: DocumentTypesPage
        },
        {
            path: '/charge-types',
            name: 'chargetypes',
            component: ChargeTypesPage
        },
        {
            path: '/packages',
            name: 'packages',
            component: PackagesPage
        },
        {
            path: '/vehicles',
            name: 'vehicles',
            component: VehiclesPage
        },
        {
            path: '/company',
            name: 'company',
            component: CompanyPage
        },
        {
            path: '/customers',
            name: 'customers',
            component: CustomersPage
        },
        {
            path: '/documents/transportation/new',
            name: 'newtransportationdocument',
            component: NewTransportationDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/transportation/list',
            name: 'transportationdocuments',
            component: TransportationDocumentsPage
        },
        {
            path: '/documents/transportation/:id',
            name: 'edittransportationdocument',
            component: EditTransportationDocumentPage
        },
        {
            path: '/documents/income/new',
            name: 'newincomedocument',
            component: NewIncomeDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/income/list',
            name: 'incomedocuments',
            component: IncomeDocumentsPage
        },
        {
            path: '/accounts/ledgers',
            name: 'ledgers',
            component: LedgersPage
        },
        {
            path: '/ledgers',
            name : 'ledgers2',
            component: AccountLedgerPage
        },
        {
            path: '/documents/service/new',
            name: 'newservicedocument',
            component: NewServiceDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/service/list',
            name: 'servicedocuments',
            component: ServiceDocumentsPage
        },
        {
            path: '/documents/service/:id',
            name: 'editservicedocument',
            component: EditServiceDocumentPage
        },
        {
            path: '/documents/sales/new',
            name: 'newsalesdocument',
            component: NewSalesDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/sales/list',
            name: 'salesdocuments',
            component: SalesDocumentsPage
        },
        {
            path: '/documents/purchases/new',
            name: 'newpurchasedocument',
            component: NewPurchaseDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/purchases/list',
            name: 'purchasedocuments',
            component: PurchaseDocumentsPage
        },
        {
            path: '/documents/purchases/:id',
            name: 'editpurchasedocument',
            component: EditPurchaseDocumentPage
        },

        {
            path: '/products',
            name: 'products',
            component: ProductsPage
        },
        {
            path: '/product-categories',
            name: 'product-categories',
            component: ProductCategoriesPage
        },
        {
            path: '/reports/sales',
            name: 'report-sales',
            component: SalesPage
        },
        {
            path: '/documents/warehouse/new',
            name: 'newwarehousedocument',
            component: NewWarehouseDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/warehouse/list',
            name: 'warehousedocuments',
            component: WarehouseDocumentsPage
        },
        {
            path: '/products/branch-stocks',
            name: 'branchstocks',
            component: BranchStocksPage
        },
        {
            path: '/documents/warehouse/invoice',
            name: 'newwarehousedocumentinvoice',
            component: NewWarehouseDocumentInvoicePage
        },
        {
            path: '/documents/payment/new',
            name: 'newpaymentdocument',
            component: NewPaymentDocumentPage
        },
        {
            path: '/documents/payment/list',
            name: 'paymentdocuments',
            component: PaymentDocumentsPage
        },
        {
            path: '/documents/internalshipping/new',
            name: 'newinternalshippingdocument',
            component: NewInternalShippingDocumentPage
        },
        {
            path: '/documents/internalshipping/list',
            name: 'internalshippingdocuments',
            component: InternalShippingDocumentsPage
        },
        {
            path: '/expenses/new',
            name: 'newexpense',
            component: NewExpensePage
        },
        {
            path: '/expense-templates',
            name: 'expensetemplates',
            component: ExpenseTemplatesPage
        },
        {
            path: '/expenses',
            name: 'expensedocuments',
            component: ExpenseDocumentsPage
        },
        {
            path: '/reports/sales-averages',
            name: 'report-sales-averages',
            component: ReportSalesAveragesPage
        },
        {
            path: '/reports/sales-per-customer',
            name: 'report-sales-per-customer',
            component: ReportSalesPerCustomerPage
        },
        {
            path: '/reports/sales-per-product',
            name: 'report-sales-per-product',
            component: ReportSalesPerProductPage
        },
        {
            path: '/reports/customers-balance',
            name: 'report-customers-balance',
            component: ReportCustomersBalancePage
        },
        {
            path: '/reports/order-sums-per-customer',
            name: 'report-order-sums-per-customer',
            component: ReportOrderSumsPerCustomerPage
        },
        {
            path: '/reports/order-sums-per-distributor',
            name: 'report-order-sums-per-distributor',
            component: ReportOrderSumsPerDistributorPage
        },
        {
            path: '/reports/sales-sums-per-customer',
            name: 'report-sales-sums-per-customer',
            component: ReportSalesSumsPerCustomerPage
        },
        {
            path: '/reports/export-esoda-epsilon-b',
            name: 'report-export-esoda-epsilon-b',
            component: ReportExportEsodaEpsilonBPage
        },
        {
            path: '/reports/export-eksoda-epsilon-b',
            name: 'report-export-eksoda-epsilon-b',
            component: ReportExportEksodaEpsilonBPage
        },

        {
            path: '/reports/export-esoda-epsilon-c',
            name: 'report-export-esoda-epsilon-c',
            component: ReportExportEsodaEpsilonCPage
        },
        {
            path: '/reports/export-eksoda-epsilon-c',
            name: 'report-export-eksoda-epsilon-c',
            component: ReportExportEksodaEpsilonCPage
        },


        {
            path: '/reports/export-accounts-epsilon',
            name: 'report-export-accounts-epsilon',
            component: ReportExportAccountsEpsilonPage
        },
        {
            path: '/reports/stock-movements',
            name: 'report-stock-movements',
            component: ReportStockMovementsPage
        },
        {
            path: '/reports/tziros-per-month',
            name: 'report-tziros-per-month',
            component: ReportTzirosPerMonth
        },
        {
            path: '/documents/sales-orders/new',
            name: 'newsalesorderdocument',
            component: NewSalesOrderDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/sales-orders/list',
            name: 'salesorderdocuments',
            component: SalesOrderDocumentsPage
        },
        {
            path: '/documents/sales-orders/invoice',
            name: 'newsalesorderdocumentinvoicepage',
            component: NewSalesOrderDocumentInvoicePage
        },
        {
            path: '/documents/sales-orders/:id',
            name: 'editsalesorderdocument',
            component: NewSalesOrderDocumentPage
        },
        {
            path: '/reports/sales-per-day',
            name: 'report-sales-per-day',
            component: ReportSalesPerDayPage
        },
        {
            path: '/reports/fortoseis-ana-dianomea',
            name: 'report-fortoseis-ana-dianomea',
            component: ReportFortoseisAnaDianomeaPage
        },
        {
            path: '/reports/order-sums-per-supplier',
            name: 'report-order-sums-per-supplier',
            component: ReportOrderSumsPerSupplierPage
        },
        {
            path: '/reports/quantity-per-month',
            name: 'report-quantity-per-month',
            component: ReportQuantityPerMonthPage
        },
        {
            path: '/contracts',
            name: 'contracts',
            component: ContractsPage
        },

        {
            path: '/contracts/:id',
            name: 'contractpage',
            component: ContractPage
        },

        {
            path: '/reports/purchases-per-supplier',
            name: 'report-purchases-per-supplier',
            component: ReportPurchasesPerSupplier
        },

        {
            path: '/new-offset-transaction',
            name: 'newoffsettransaction',
            component: NewOffsetTransactionPage
        },

        {
            path: '/pricelists',
            name: 'pricelists',
            component: PricelistsPage
        },
        {
            path: '/pricelists/:type/:id',
            name: 'pricelist-editor',
            component: PricelistEditorPage
        },

        // {
        //     path: '/distribution-itineraries-per-day',
        //     name: 'distribution-itineraries-per-day',
        //     component: DistributionItinerariesPerDayPage
        // }
        
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.noexpired) {

        let user = store.state.currentUser.user

        if (user.subscription_expired) {
            next({ name: 'home' })
        }
        else {
            next()
        }
    }
    else {
        next()
    }
})


const app = new Vue({
    el: '#app',
    vuetify: Vuetify,
    router,
    store,
});
